module.exports = __webpack_public_path__ + "img/日化.c0246cc7.png";